import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { SvgIcon } from '@adsk/bim360-matrix-react-components';
import iconInfo from '../../../../../assets/images/icons/icon-info.svg';

export default class extends PureComponent {

  static displayName = 'ToolTip';

  static propTypes = {
    hoverText: PropTypes.string,
  };

  constructor() {
    super();
    this.state = {
      iconHeight: 0,
      iconWidth: 0,
    };
    this._calcTooltipPosition = this._calcTooltipPosition.bind(this);
  }

  componentDidMount() {
    this._calcTooltipPosition();
  }

  //get icon position
  _calcTooltipPosition() {
    this.setState({
      iconHeight: this.infoIcon.getBoundingClientRect().top,
      iconWidth: this.infoIcon.getBoundingClientRect().left,
    });
  }

  //render the mouse hover info
  _hoverInfoBox() {
    return (
      <div className="issue-ui-tooltip__hover-box" style={{ top: this.state.iconHeight + 21, left: this.state.iconWidth - 20 }}>{this.props.hoverText}</div>
    );
  }

  render() {
    return (
      <div className="issue-ui-tooltip" onMouseOver={this._calcTooltipPosition} ref={(instance) => { this.infoIcon = instance; }}>
        <span className="issue-ui-tooltip__icon">
          <SvgIcon>
            {iconInfo}
          </SvgIcon>
          {this._hoverInfoBox()}
        </span>
      </div >
    );
  }
}
